module.exports = __webpack_public_path__ + "img/dep_produce@3x.8cb9e589.png";